/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFinding {
    getFixupPrototypeFunction() { return AwsSecurityHubFinding.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFinding>): AwsSecurityHubFinding {
        let obj = Object.assign(new AwsSecurityHubFinding(), model);
        AwsSecurityHubFinding.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFinding>): AwsSecurityHubFinding {
        if (!model) return null;
        return AwsSecurityHubFinding.newInstance(<AwsSecurityHubFinding> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFinding) {
        if (!obj) return;

        models.AwsSecurityHubFinding.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFinding): boolean {
        Object.setPrototypeOf(obj, AwsSecurityHubFinding.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.finding_created_at === "string") {
            this.finding_created_at = new Date(<string><any>this.finding_created_at);
        }
        if (typeof this.finding_updated_at === "string") {
            this.finding_updated_at = new Date(<string><any>this.finding_updated_at);
        }
        if (this.resources) {
            for (let val of this.resources) {
                models.AwsSecurityHubFindingResource.fixupPrototype(val);
            }
        }
    }

    /**
     * Severity label
     */
    severity: models.AwsSecurityHubSeverity;

    /**
     * Record status
     */
    record_state: models.AwsSecurityHubRecordState;

    /**
     * Workflow status
     */
    workflow_status: models.AwsSecurityHubWorkflowStatus;

    /**
     * Findings region
     */
    region: string;

    /**
     * AWS account id
     */
    aws_account_id: string;

    /**
     * Corestack cloud account id
     */
    cloud_account_id: string;

    /**
     * Company name
     */
    company_name: string;

    /**
     * Product name
     */
    product_name: string;

    /**
     * Findings title
     */
    title: string;

    /**
     * Impacted resources
     */
    resources: Array<models.AwsSecurityHubFindingResource>;

    /**
     * Compliance status
     */
    compliance_status: models.AwsSecurityHubComplianceStatus;

    /**
     * Related Contorl ARN
     */
    compliance_related_requirements: Array<string>;

    compliance_security_control_id: string;

    compliance_rule: string;

    /**
     * Associated Compliance Standards
     */
    compliance_associated_standards: Array<string>;

    /**
     * Findings created time
     */
    finding_created_at: Date;

    /**
     * Findings updated time
     */
    finding_updated_at: Date;

    /**
     * Findings description
     */
    description: string;

    /**
     * Finding Id
     */
    finding_id: string;

    /**
     * Recommendation description
     */
    recommendation_text: string;

    /**
     * Recommendation Link
     */
    recommendation_url: string;

    /**
     * Severity label
     */
    finding_provider_severity: models.AwsSecurityHubSeverity;

    /**
     * Resource Id
     */
    finding_provider_types: Array<string>;

    /**
     * Related findings
     */
    finding_provider_related_findings: Array<string>;

}
